import { faPlus, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { FunctionComponent } from 'react';
import clsx from 'clsx';
import Button from 'components/UI/V2/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface HeaderProps {
    id?: string;
    title: string | JSX.Element | React.ReactNode;
    buttonLabel?: string;
    onClick?: () => void;
    onBack?: () => void;
    className?: string;
    displayButton?: boolean;
    buttonIcon?: IconDefinition;
    tooltipOptions?: JSX.Element;
    leftContentClassName?: string;
    rightContentClassName?: string;
    textBelowTitle?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        containerWithTextBelowTitle: {
            alignItems: 'flex-start'
        },
        leftContent: {
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            position: 'relative',
            [theme.breakpoints.down('sm')]: {
                alignItems: 'flex-start',
                paddingRight: 7
            }
        },
        title: {
            fontSize: 20,
            lineHeight: '120%',
            fontWeight: 600,
            color: '#222222',
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.up('md')]: {
                fontSize: 24
            },
            [theme.breakpoints.down('sm')]: {
                alignItems: 'flex-start'
            }
            /*
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                alignItems: 'flex-start'
            }*/
        },
        textBelowTitle: {
            fontSize: 16,
            lineHeight: '120%',
            fontWeight: 400,
            color: '#000',
            position: 'relative',
            left: 0,
            marginTop: 8
        },
        button: {
            'height': 55,
            'padding': '0px 20px',
            '& .MuiButton-startIcon': {
                '& svg': {
                    width: 16,
                    height: 16,
                    [theme.breakpoints.down('lg')]: {
                        width: 14,
                        height: 14
                    }
                }
            },
            '& span': {
                fontSize: 18,
                fontWeight: 600
            },
            [theme.breakpoints.down('lg')]: {
                'height': 39,
                'width': 'min-content',
                '& span': {
                    fontSize: 14,
                    fontWeight: 600
                }
            }
        },
        backIcon: {
            color: '#222222',
            fontSize: 22,
            fontWeight: 500,
            cursor: 'pointer',
            marginRight: 12,
            [theme.breakpoints.down('md')]: {
                fontSize: 20
            },
            [theme.breakpoints.down('sm')]: {
                position: 'relative',
                top: 2,
                marginRight: 8
            }
        },
        rightContent: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 12
        },
        tooltipOptions: {
            position: 'relative'
        }
    })
);

export const DefaultHeader: FunctionComponent<HeaderProps> = props => {
    const classes = useStyles();

    const containerCombinedClassName = clsx(classes.container, props.className, {
        [classes.containerWithTextBelowTitle]: props.textBelowTitle
    });

    return (
        <>
            <Box className={containerCombinedClassName}>
                <Box className={clsx(classes.leftContent, props.leftContentClassName)}>
                    <Typography className={classes.title}>
                        {props.onBack && (
                            <FontAwesomeIcon
                                className={classes.backIcon}
                                icon={faArrowLeft}
                                onClick={props.onBack}
                            />
                        )}
                        {props.title}
                    </Typography>
                    {props.textBelowTitle && (
                        <Typography className={classes.textBelowTitle}>{props.textBelowTitle}</Typography>
                    )}
                </Box>
                <Box className={clsx(classes.rightContent, props.rightContentClassName)}>
                    {props.buttonLabel && props.displayButton && (
                        <Button
                            id={props.id}
                            leftIcon={props.buttonIcon}
                            label={props.buttonLabel}
                            onClick={props.onClick}
                        />
                    )}
                    {props.tooltipOptions && <Box className={classes.tooltipOptions}>{props.tooltipOptions}</Box>}
                </Box>
            </Box>
        </>
    );
};

export default DefaultHeader;
